import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#8B2635",
      contrastText: "#FBF8F3",
    },
    secondary: {
      main: "#C9A961",
      contrastText: "#2B2118",
    },
    background: {
      default: "#FBF8F3",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#2B2118",
      secondary: "#6B5B4F",
    },
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    h1: { fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 600 },
    h2: { fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 600 },
    h3: { fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 600 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 10,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#FBF8F3",
        },
      },
    },
  },
});

export default theme;
